(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6869],{

/***/ 9803:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



function SvgArrow(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  })), _path2 || (_path2 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M7.828 11H20v2H7.828l5.364 5.364-1.414 1.414L4 12l7.778-7.778 1.414 1.414z"
  })));
}

/* harmony default export */ __webpack_exports__["Z"] = (SvgArrow);

/***/ }),

/***/ 11120:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/faq/[slug]",
      function () {
        return __webpack_require__(71901);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 93335:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ TOC; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _sindresorhus_slugify__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(46831);
/* harmony import */ var _sindresorhus_slugify__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_sindresorhus_slugify__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _components_renderers_Link__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(31515);
/* harmony import */ var _components_renderers_Heading__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(27910);
/* harmony import */ var _components_Button__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(68663);
/* harmony import */ var _svg_icons_remix_arrow_down_line_svg__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(46396);








function TOC(param) {
    var links = param.links, togglerRequired = param.togglerRequired, textSizes = param.textSizes, heading = param.heading;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(true), isOpen = ref[0], setOpen = ref[1];
    var toggleNav = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        return setOpen(function(status) {
            return !status;
        });
    }, []);
    var headingClass = "font-black leading-snug text-xl pt-8 px-12 md:px-8 md:text-lg lg:px-6 xl:text-xl";
    var ulClass = classnames__WEBPACK_IMPORTED_MODULE_2___default()('list-none px-12 pb-6 w-full', {
        'pt-2 md:pl-8 md:pr-4 lg:pl-6': isOpen,
        'xl:p-0': !isOpen
    });
    var liClass = classnames__WEBPACK_IMPORTED_MODULE_2___default()('hover:underline leading-tight my-4 xl:my-2', {
        'xl:invisible xl:h-0': !isOpen
    });
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("nav", {
        className: "relative mb-6 box-border w-full rounded-md bg-gray-200",
        children: [
            togglerRequired === true ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Button__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                className: "xl:w-full",
                colour: "purple",
                appearance: "outline",
                onClick: toggleNav,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "flex w-full flex-row items-center",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_renderers_Heading__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                            level: 4,
                            className: headingClass,
                            children: heading || 'Table of contents'
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_svg_icons_remix_arrow_down_line_svg__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                            className: "h-4 w-5 transform fill-current transition-transform duration-100 xl:order-last ".concat(isOpen && '-rotate-90')
                        })
                    ]
                })
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
                className: headingClass,
                children: heading || 'Table of contents'
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                className: ulClass,
                children: links.map(function(link, index) {
                    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                        className: liClass,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_renderers_Link__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                            className: textSizes ? classnames__WEBPACK_IMPORTED_MODULE_2___default()('text-cornflower', textSizes) : 'text-base text-cornflower xl:text-sm',
                            href: "#".concat(_sindresorhus_slugify__WEBPACK_IMPORTED_MODULE_3___default()(link, {
                                customReplacements: [
                                    [
                                        '/',
                                        ''
                                    ],
                                    [
                                        '.',
                                        ''
                                    ], 
                                ],
                                decamelize: false
                            })),
                            children: link
                        })
                    }, index);
                })
            })
        ]
    }));
};


/***/ }),

/***/ 71901:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; },
/* harmony export */   "default": function() { return /* binding */ FAQCategory; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9008);
/* harmony import */ var _sindresorhus_slugify__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(46831);
/* harmony import */ var _sindresorhus_slugify__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_sindresorhus_slugify__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react_schemaorg__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(45363);
/* harmony import */ var _components_Layout_Vanilla__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(1635);
/* harmony import */ var _components_Hero__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(52456);
/* harmony import */ var _components_Section__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(67576);
/* harmony import */ var _components_MarkdownRenderer__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(89338);
/* harmony import */ var _components_renderers_Heading__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(27910);
/* harmony import */ var _components_TOC__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(93335);
/* harmony import */ var _components_Button__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(68663);
/* harmony import */ var _svg_icons_arrow_svg__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(9803);
/* harmony import */ var _utils_serializeJsonLd__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(66096);














function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var __N_SSG = true;
function FAQCategory(_param) {
    var preview = _param.preview, faqs = _param.faqCategory.faqs, page = _objectWithoutProperties(_param.faqCategory, [
        "faqs"
    ]);
    var headings = faqs.map(function(param) {
        var question = param.question;
        return question;
    });
    var mainEntity = faqs.length > 0 && faqs.map(function(param) {
        var name = param.question, answer = param.answer;
        var mdRegexp = /\[|\]\(.*\)|[#*]/gi;
        var text = (0,_utils_serializeJsonLd__WEBPACK_IMPORTED_MODULE_13__/* .serialize */ .q)(answer.replace(mdRegexp, ''));
        return {
            '@type': 'Question',
            name: name,
            acceptedAnswer: {
                '@type': 'Answer',
                text: text
            }
        };
    });
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_Layout_Vanilla__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
        seo: page,
        preview: preview,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_head__WEBPACK_IMPORTED_MODULE_2__["default"], {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", _objectSpread({}, (0,react_schemaorg__WEBPACK_IMPORTED_MODULE_4__/* .jsonLdScriptProps */ .h6)({
                    '@context': 'https://schema.org',
                    '@type': 'FAQPage',
                    mainEntity: mainEntity
                })))
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Section__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                size: "small",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Hero__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, _objectSpread({}, page))
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "container mx-auto pt-0 md:flex md:flex-row md:overflow-visible",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("aside", {
                        className: "px-8 md:sticky md:mt-10 md:mb-6 md:max-h-3/4 md:w-1/3 md:overflow-y-auto md:pr-0 lg:order-first lg:ml-10 lg:w-1/4",
                        style: {
                            top: '160px'
                        },
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_TOC__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                textSizes: "xl:text-sm md:text-sm",
                                links: headings,
                                heading: "In this category:"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_Button__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                                block: true,
                                className: "flex flex-row justify-center",
                                colour: "purple",
                                href: "/faq",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_svg_icons_arrow_svg__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                                        title: "Leftwards arrow",
                                        className: "mr-3 inline h-6 fill-current"
                                    }),
                                    "View all FAQs"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("main", {
                        className: "mb-16 px-8 md:w-2/3 lg:order-last lg:w-3/4 lg:px-12",
                        children: faqs.map(function(param) {
                            var id = param.id, question = param.question, answer = param.answer;
                            /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_renderers_Heading__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                        id: _sindresorhus_slugify__WEBPACK_IMPORTED_MODULE_3___default()(question, {
                                            customReplacements: [
                                                [
                                                    '/',
                                                    ''
                                                ],
                                                [
                                                    '.',
                                                    ''
                                                ], 
                                            ],
                                            decamelize: false
                                        }),
                                        level: 2,
                                        children: question
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_MarkdownRenderer__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                        content: answer
                                    })
                                ]
                            }, id);
                        })
                    })
                ]
            })
        ]
    }));
};


/***/ }),

/***/ 66096:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "q": function() { return /* binding */ serialize; }
/* harmony export */ });
function serialize(target) {
    return JSON.stringify(target).slice(1, -1);
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3781,4814,3353,8009,6831,5343,1635,2456,9338,9774,2888,179], function() { return __webpack_exec__(11120); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);